export interface BuildingRenderConfig {
  readonly oldTownMinimumRoofRiseM: number;
  readonly oldTownMaximumRoofRiseM: number;
  readonly oldTownMaximumRoofHeightRatio: number;
  readonly roofEaveOverhangM: number;
  readonly roofMinimumRectangularityRatio: number;
  readonly hipRidgeInsetRatio: number;
  readonly mansardBreakRatio: number;
  readonly mansardBreakHeightRatio: number;
  readonly lod1HeightScale: number;
  readonly lod2HeightScale: number;
}

/** M4-reviewed visual massing values; source confidence remains on each spec. */
export const BUILDING_RENDER_CONFIG: BuildingRenderConfig = Object.freeze({
  oldTownMinimumRoofRiseM: 1.2,
  oldTownMaximumRoofRiseM: 4.8,
  oldTownMaximumRoofHeightRatio: 0.36,
  roofEaveOverhangM: 0.35,
  roofMinimumRectangularityRatio: 0.62,
  hipRidgeInsetRatio: 0.24,
  mansardBreakRatio: 0.28,
  mansardBreakHeightRatio: 0.72,
  lod1HeightScale: 0.94,
  lod2HeightScale: 0.86,
});

/**
 * Stable per-building occupancy bands for the shared facade emissive atlas.
 * Detailed windows still choose individual lit panes; these quieter factors
 * stop background blocks from illuminating every repeated window at once.
 */
export const BUILDING_WINDOW_NIGHT_INTENSITY_FACTORS = Object.freeze([
  0,
  0.08,
  0.34,
  0.7,
] as const);

/**
 * Authored windows sit proud of the generated facade atlas and therefore need
 * a lower night intensity than small texture-atlas panes. Keeping this below
 * the former 2.6 multiplier prevents entrances from reading as white cut-outs.
 */
export const AUTHORED_WINDOW_NIGHT_INTENSITY = 1.55;
